<template>
  <div class="data_div">
    <!-- 标题 -->
    <div class="data_title_box">
      <i class="iconfont icon-dian"></i>
      <span>{{ title }}</span>
    </div>
    <div class="data_right_box">
      <!-- 搜索部分 -->
      <div class="select_left">
        <!-- 模糊条件 -->
        <div class="search_box">
          <span> 关键字</span>
          <div>
            <el-input class="input_width input_inner" placeholder="请输入搜索关键字" v-model="keywordVal" maxLength="20"
                      clearable></el-input>
          </div>
        </div>

        <!-- 单位选择 -->
        <div class="search_box">
          <span>单位选择</span>
          <div>
            <el-select v-model="companySelVal" placeholder="请选择内容" @change="companyChange" clearable>
              <el-option v-for="item in companyList"
                         :key="item.id"
                         :label="item.comName"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 电站选择 -->
        <div class="search_box">
          <span>电站选择</span>
          <div>
            <el-select v-model="stationSelVal" placeholder="请选择内容" @change="stationChange">
              <el-option v-for="item in stationList"
                         :key="item.id"
                         :label="item.stationName"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 设备选择 -->
        <div class="search_box">
          <span>设备选择</span>
          <div>
            <el-select v-model="devSelVal" placeholder="请选择内容" clearable>
              <el-option v-for="item in devList"
                         :key="item.id"
                         :label="item.devName"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 源类型 -->
        <div class="search_box">
          <span>源类型</span>
          <div>
            <el-select v-model="sourceTypeSelVal" placeholder="请选择内容" clearable>
              <el-option v-for="item in sourceTypeList"
                         :key="item.infoCode"
                         :label="item.infoName"
                         :value="item.infoCode">
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 模块类型 -->
        <div class="search_box">
          <span>模块类型</span>
          <div>
            <el-select v-model="modelTypeSelVal" placeholder="请选择内容" clearable>
              <el-option v-for="item in modelTypeList"
                         :key="item.infoCode"
                         :label="item.infoName"
                         :value="item.infoCode">
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 累积量类型 -->
        <div class="search_box">
          <span>累积量类型</span>
          <div>
            <el-select v-model="cumulateTypeSelVal" placeholder="请选择内容" clearable>
              <el-option v-for="item in cumulateTypeList"
                         :key="item.infoCode"
                         :label="item.infoName"
                         :value="item.infoCode">
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 生效标记 -->
        <div class="search_box">
          <span>生效标记</span>
          <div>
            <el-select v-model="enableSignSelVal" placeholder="请选择内容" clearable>
              <el-option v-for="item in enableSignList"
                         :key="item.infoCode"
                         :label="item.infoName"
                         :value="item.infoCode">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <!-- 搜索按钮 -->
      <div class="btn_right">
        <button class="button_style0" @click="selectButClick"><i class="iconfont icon-chaxun4"></i>查询</button>
      </div>
    </div>

    <!-- 翻页器 -->
    <div class="pagination_div">
      <el-pagination background class="el_pag"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-size="pageSize"
                     layout="total, prev, pager, next, jumper"
                     :total="pageTotal">
      </el-pagination>
      <div class="function_button_div">
        <button class="button_style1 btn_add" @click="addClick"><i class="iconfont icon-tianjia3"></i>增加</button>
        <button v-if="(this.sourceTypeSelVal>0||this.modelTypeSelVal>0||this.stationSelVal > 0)
        && this.dataList.length > 0" class="button_style1" @click="deleteClick()">
          <i class="iconfont icon-shanchu"></i>删除所有
        </button>
      </div>

    </div>

    <!--数据表格部分  -->
    <div class="list_box">
      <el-table border :data="dataList" size="mini"
                class="my_el_table"
                style="width: 100%" height="100%"
                v-loading="loading"
                element-loading-text="加载中，请稍后..."
                element-loading-background="#00151b"
                :cell-style="rowClassName"
                :header-cell-style="ListTableHeaderColor">
        <el-table-column label="id" prop="id" width="" fixed show-overflow-tooltip></el-table-column>
        <!-- <el-table-column label="记录名称" prop="recordName" width="100" show-overflow-tooltip></el-table-column> -->
        <el-table-column label="数据名称" prop="dataName" fixed width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="数据key" prop="dataKey" fixed width="" show-overflow-tooltip></el-table-column>        
        <el-table-column label="数据单位" prop="dataUnit" fixed width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="默认值" prop="defaultValue" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="源类型" prop="sourceTypeStr" fixed width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="模块类型" prop="modelTypeStr" fixed width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="码索引" prop="codeIndex" width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="分组标记" prop="groupSign" width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="分组名称" prop="groupName" width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="瞬时量" prop="instantId" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
              <span>
               {{ convertInstantName(scope.row.instantId) }}
              </span>
          </template>
        </el-table-column>
        <el-table-column label="累积量" prop="cumulateId" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
              <span>
               {{ convertCumulateName(scope.row.cumulateId) }}
              </span>
          </template>
        </el-table-column>
        <el-table-column label="累积量类型" prop="cumulateTypeStr" width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="默认值" prop="defaultValue" width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="转换系数" prop="ratio" width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="转换截距" prop="base" width="" show-overflow-tooltip></el-table-column>\
        <el-table-column label="小数位" prop="decimalLenStr" width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="排序号" prop="sortNumber" width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="图标" prop="icon" width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="生效标记" prop="enableSignStr" width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <button class="button_style2" @click="detailsClick( scope.row.id,scope.row.devId)"> 详情</button>
            <i class="iconfont icon-vertical_line operation_line"></i>
            <button class="button_style2" @click="editClick( scope.row.id,scope.row.devId)"> 编辑</button>
            <i class="iconfont icon-vertical_line operation_line"></i>
            <button class="button_style2" @click="delClick(scope.row.id,scope.row.dataName)"> 删除</button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 弹窗 -->
    <el-dialog :visible.sync="dialogTableVisible" :append-to-body="true" :lock-scroll="false"
               :close-on-click-modal="false" @close="closeDialog">
      <div slot="title" class="dialog_title">{{ dialog.title }}</div>
      <div class="dialog_content">
        <el-form :model="dialog.elForm" :rules="dialog.rules" ref="addAlterForm">
          <el-form-item label="记录名称" prop="recordName" label-width="17rem">
            <el-input
                :disabled='dialog.openType == 0'
                v-model="dialog.elForm.recordName"
                maxlength="20"
                placeholder="请输入内容"></el-input>
            <span class="remark_span">不超过20个字符</span>
          </el-form-item>
          <el-form-item label="数据名称" prop="dataName" label-width="17rem">
            <el-input
                :disabled='dialog.openType == 0'
                v-model="dialog.elForm.dataName"
                maxlength="20"
                placeholder="请输入内容"></el-input>
            <span class="remark_span">不超过20个字符</span>
          </el-form-item>
          <el-form-item label="默认值" prop="defaultValue" label-width="17rem">
            <el-input
                :disabled='dialog.openType == 0'
                v-model="dialog.elForm.defaultValue"
                maxlength="20"
                placeholder="请输入内容"></el-input>
            <span class="remark_span">不超过20个字符</span>
          </el-form-item>
          <el-form-item label="数据单位" prop="dataUnit" label-width="17rem">
            <el-input
                :disabled='dialog.openType == 0'
                v-model="dialog.elForm.dataUnit"
                maxlength="20"
                placeholder="请输入内容"></el-input>
            <span class="remark_span">不超过20个字符</span>
          </el-form-item>
          <el-form-item label="源类型" prop="sourceType" label-width="17rem">
            <el-select v-model="dialog.elForm.sourceType" placeholder="请选择内容" clearable
                       @change="handleSourceTypeChange" :disabled='dialog.openType == 0'>
              <el-option v-for="item in sourceTypeList"
                         :key="item.infoCode"
                         :label="item.infoName"
                         :value="item.infoCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模块类型" prop="modelType" label-width="17rem">
            <el-select v-model="dialog.elForm.modelType" placeholder="请选择内容" clearable
                       :disabled='dialog.openType == 0'>
              <el-option v-for="item in modelTypeList"
                         :key="item.infoCode"
                         :label="item.infoName"
                         :value="item.infoCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备" prop="devId" label-width="17rem">
            <el-select v-model="dialog.elForm.devId" @change="handleDevChange" placeholder="请选择内容" clearable
                       :disabled='dialog.openType == 0'>
              <el-option v-for="item in devList"
                         :key="item.id"
                         :label="item.devName"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据点" prop="dataKey" label-width="17rem">
            <el-select v-model="dialog.elForm.dataKey" @change="dataKeyChange" placeholder="请选择内容" clearable
                       :disabled='dialog.openType == 0'>
              <el-option v-for="item in dataPointList"
                         :key="item.dataKey"
                         :label="item.dataName"
                         :value="item.dataKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="码索引" prop="codeIndex" label-width="17rem">
            <el-select v-model="dialog.elForm.codeIndex" placeholder="请选择内容" clearable
                       :disabled='dialog.openType == 0'>
              <el-option v-for="item in tableAlarmList"
                         :key="item.codeIndex"
                         :label="item.codeInfo"
                         :value="item.codeIndex">
              </el-option>
            </el-select>
            <span class="remark_span">如果是Bit码有效</span>
          </el-form-item>
          <el-form-item label="瞬时量" prop="instantId" label-width="17rem">
            <el-select v-model="dialog.elForm.instantId" @change="chartSelect(true)" placeholder="请选择内容" clearable
                       :disabled='dialog.openType == 0'>
              <el-option v-for="item in curveList"
                         :key="item.id"
                         :label="item.recordName"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="累积量" prop="cumulateId" label-width="17rem">
            <el-select v-model="dialog.elForm.cumulateId" @change="chartSelect(false)" placeholder="请选择内容"
                       clearable
                       :disabled='dialog.openType == 0'>
              <el-option v-for="item in cumulateList"
                         :key="item.id"
                         :label="item.recordName"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="累积量类型" prop="cumulateType" label-width="17rem">
            <el-select v-model="dialog.elForm.cumulateType" placeholder="请选择内容"
                       :disabled='dialog.openType == 0'>
              <el-option v-for="item in cumulateTypeList"
                         :key="item.infoCode"
                         :label="item.infoName"
                         :value="item.infoCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="转换系数" prop="ratio" label-width="17rem">
            <el-input
                :disabled='dialog.openType == 0'
                v-model="dialog.elForm.ratio"
                maxlength="20"
                placeholder="请输入内容"></el-input>
            <span class="remark_span">不超过20个字符</span>
          </el-form-item>
          <el-form-item label="转换截距" prop="base" label-width="17rem">
            <el-input
                :disabled='dialog.openType == 0'
                v-model="dialog.elForm.base"
                maxlength="20"
                placeholder="请输入内容"></el-input>
            <span class="remark_span">不超过20个字符</span>
          </el-form-item>
          <el-form-item label="分组标记" prop="groupSign" label-width="17rem">
            <el-input
                :disabled='dialog.openType == 0'
                v-model="dialog.elForm.groupSign"
                maxlength="20"
                placeholder="请输入内容"></el-input>
            <span class="remark_span">不超过20个字符</span>
          </el-form-item>
          <el-form-item label="分组名称" prop="groupName" label-width="17rem">
            <el-input
                :disabled='dialog.openType == 0'
                v-model="dialog.elForm.groupName"
                maxlength="20"
                placeholder="请输入内容"></el-input>
            <span class="remark_span">不超过20个字符</span>
          </el-form-item>
          <el-form-item label="小数位" prop="decimalLen" label-width="17rem">
            <el-select v-model="dialog.elForm.decimalLen" placeholder="请选择内容"
                       :disabled='dialog.openType == 0'>
              <el-option v-for="item in decimalLenList"
                         :key="item.infoCode"
                         :label="item.infoName"
                         :value="item.infoCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序号" prop="sortNumber" label-width="17rem">
            <el-input
                :disabled='dialog.openType == 0'
                v-model="dialog.elForm.sortNumber"
                maxlength="20"
                placeholder="请输入内容"></el-input>
            <span class="remark_span">不超过20个字符</span>
          </el-form-item>
          <el-form-item label="图标" prop="icon" label-width="17rem">
            <el-input
                :disabled='dialog.openType == 0'
                v-model="dialog.elForm.icon"
                maxlength="20"
                placeholder="请输入内容"></el-input>
            <span class="remark_span">不超过20个字符</span>
          </el-form-item>
          <el-form-item label="生效标记" prop="enableSign" label-width="17rem">
            <el-select v-model="dialog.elForm.enableSign" placeholder="请选择内容"
                       :disabled='dialog.openType == 0'>
              <el-option v-for="item in enableSignList"
                         :key="item.infoCode"
                         :label="item.infoName"
                         :value="item.infoCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述/备注" prop="remark" label-width="17rem">
            <el-input type="textarea" v-model="dialog.elForm.remark" maxlength="100"
                      placeholder="请输入内容"></el-input>
            <span class="remark_span">不超过100个字符</span>
          </el-form-item>
        </el-form>
        <table class="dialog_table" v-if="dialog.openType === 0">
          <tr>
            <td>添加用户</td>
            <td>{{ dialog.elForm.addUser }}</td>
          </tr>
          <tr>
            <td>添加时间</td>
            <td>{{ longToDate(dialog.elForm.addTime) }}</td>
          </tr>
          <tr>
            <td>最近一次修改用户</td>
            <td>{{ dialog.elForm.alterUser }}</td>
          </tr>
          <tr>
            <td>最近一次修改时间</td>
            <td>{{ longToDate(dialog.elForm.alterTime) }}</td>
          </tr>
        </table>
      </div>
      <div slot="footer" class="dialog_footer">
        <button class="button_style0" @click="dialogTableVisible=false"><i class="iconfont icon-quxiao1"></i>取消
        </button>
        <button class="button_style0" @click="submitClick('addAlterForm')" v-if="dialog.openType!=0"><i
            class="iconfont icon-tijiao"></i>保存
        </button>
        <button class="button_style0" @click="resetClick" v-if="dialog.openType!=0">
          <i class="iconfont icon-zhongzhi3"></i>重置
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import myApi from "@/util/my-api";
import myConst from "@/util/my-const";
import fun from "@/util/util";

export default {
  data() {
    return {
      title: "EMS数据配置管理",
      loading: false,

      //查询条件
      keywordVal: "", //关键字信息
      companyList: [], //单位列表
      companySelVal: "",
      stationListAll: [],
      stationList: [], //电站列表
      stationSelVal: "",
      devList: [], //设备列表
      devSelVal: "",
      sourceTypeList: [], //源类型列表
      sourceTypeSelVal: "",
      modelTypeList: [], //模块类型列表
      modelTypeSelVal: "",
      cumulateTypeList: [], //累积量类型列表
      cumulateTypeSelVal: "",
      decimalLenList: [], //小数位长度类型列表
      enableSignSelVal: "", //生效标记列表
      enableSignList: [], //生效标记列表

      //分页
      currentPage: 1,  //当前页数
      pageSize: 50,  //每页条数
      pageTotal: 0,  //记录总数

      //数据
      dataList: [], //数据表格列表
      dataPointList: [], //数据点列表
      curveList: [], //瞬时量列表
      cumulateList: [], //累积量列表
      tableAlarmList: [], //点表告警码列表
      comparisonData: {}, //记录查询的单条记录信息

      //弹窗
      dialogTableVisible: false,
      dialog: {
        title: "",
        openType: 0, //操作类型，0：详情，1：修改，2：添加
        rules: {
          dataName: [
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          sourceType: [
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          modelType: [
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          enableSign: [
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
        },
        elForm: {
          id: "",
          recordName: "",//记录名称
          sourceType: "",//源类型
          modelType: "",//模块类型
          staId: "",//电站id
          devId: "", //设备id
          dataKey: "", //数据key
          codeIndex: "", //码索引
          instantId: "", //瞬时量id
          cumulateId: "", //累积量id
          cumulateType: "", //累积量类型
          dataName: "", //数据名称
          defaultValue: "", //默认值
          dataUnit: "", //数据单位
          ratio: "", //转换系数
          base: "", //转换截距
          groupSign: "", //分组标记
          groupName: "", //分组名称
          decimalLen: "", //小数位
          sortNumber: "", //排序号
          icon: "", //图标
          enableSign: "", //生效标记
          remark: "", //备注
        },
      }
    }
  },
  mounted() {
    this.loadCompanyList()  //获取单位列表
    this.loadStationList() //获取电站列表
    this.loadDictionaryList() //获取字典
  },
  methods: {
    //转化日期格式
    longToDate(val) {
      return fun.longToDate(val);
    },

    //获取字典
    loadDictionaryList() {
      //获取EMS源类型
      this.$axios.get(myApi.getEmsSourceType).then(res => {
        if (res.data.code === myConst.code.success) {
          this.sourceTypeList = res.data.data
        } else {
          this.sourceTypeList = []
        }
      })
      //获取EMS模块标记
      this.$axios.get(myApi.getEmsModelType).then(res => {
        if (res.data.code === myConst.code.success) {
          this.modelTypeList = res.data.data
        } else {
          this.modelTypeList = []
        }
      })
      //获取EMS累积量类型
      this.$axios.get(myApi.getEmsCumulateType).then(res => {
        if (res.data.code === myConst.code.success) {
          this.cumulateTypeList = res.data.data
        } else {
          this.cumulateTypeList = []
        }
      })
      //获取小数位长度
      this.$axios.get(myApi.getDecimalLen).then(res => {
        if (res.data.code === myConst.code.success) {
          this.decimalLenList = res.data.data
        } else {
          this.decimalLenList = []
        }
      })
      //生效标记
      this.$axios.get(myApi.getEnableSign).then(res => {
        if (res.data.code === myConst.code.success) {
          this.enableSignList = res.data.data
        } else {
          this.enableSignList = []
        }
      })
    },

    //查询单位列表
    loadCompanyList() {
      this.$axios.get(myApi.comGetPermissionCompany).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.companyList = res.data.data;
        } else {
          this.companyList = [];
        }
      });
    },

    //查询电站列表
    loadStationList() {
      this.$axios.get(myApi.getPermissionStation).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.stationListAll = res.data.data;
          this.companyChange(); //调用单位选择事件
          this.loadEmsDataList()
        } else {
          this.stationListAll = [];
        }
      });
    },

    //源类型下拉选择事件
    handleSourceTypeChange() {
      this.devRules()
      this.instantRules()
      this.cumulateRules()
    },
    //设备数据
    devRules() {
      if (this.dialog.elForm.sourceType == 1) {
        this.$set(this.dialog.rules, 'devId', [{required: true, message: '请选择内容', trigger: 'change'}]);
        this.$set(this.dialog.rules, 'dataKey', [{required: true, message: '请输入内容', trigger: 'change'}]);
        // this.$set(this.dialog.rules, 'codeIndex', [{required: true, message: '请输入内容', trigger: 'change'}]);
      } else {
        this.$set(this.dialog.rules, 'devId', []);
        this.$set(this.dialog.rules, 'dataKey', []);
        // this.$set(this.dialog.rules, 'codeIndex', []);
      }
    },
    // 瞬时量数据
    instantRules() {
      if (this.dialog.elForm.sourceType == 2) {
        this.$set(this.dialog.rules, 'instantId', [{required: true, message: '请选择内容', trigger: 'change'}]);
      } else {
        this.$set(this.dialog.rules, 'instantId', []);
      }
    },
    //累积量数据
    cumulateRules() {
      if (this.dialog.elForm.sourceType == 3) {
        this.$set(this.dialog.rules, 'cumulateId', [{required: true, message: '请选择内容', trigger: 'change'}]);
        this.$set(this.dialog.rules, 'cumulateType', [{required: true, message: '请选择内容', trigger: 'change'}]);
      } else {
        this.$set(this.dialog.rules, 'cumulateId', []);
        this.$set(this.dialog.rules, 'cumulateType', []);
      }
    },
    //查询设备列表
    loadDeviceList() {
      this.$axios.get(myApi.getDevListNew + "?stationId=" + this.stationSelVal).then(res => {
        if (res.data.code === myConst.code.success) {
          this.devList = res.data.data
        } else {
          this.devList = []
        }
      })
    },

    //单位选择改变事件
    companyChange() {
      if (fun.isNull(this.companySelVal)) {
        this.stationList = this.stationListAll;
      } else {
        this.stationList = this.stationListAll.filter((x) =>
            x.companyId === this.companySelVal
        );
      }
      if (this.stationList.length > 0) {
        this.stationSelVal = this.stationList[0].id;
      } else {
        this.stationSelVal = "";
      }
      this.stationChange();
    },

    //电站选择改变事件
    stationChange() {
      if (this.stationSelVal > 0) {
        this.loadDeviceList()
        this.loadCurveList()
        this.loadCumulateList()
      } else {
        this.deviceSelVal = ""
        this.deviceList = []
      }
      // this.loadEmsDataList()
    },

    //操作-设备选择改变事件
    handleDevChange(devId) {
      if (fun.isNull(devId)) {
        this.dataPointList = []
        return
      }
      let arr = this.devList.filter(item => {
        return item.id == devId
      })
      let ptId = arr[0].ptId
      this.dialog.elForm.dataKey = null
      this.loadDataPointList(ptId)
    },

    //操作-数据点选择改变事件
    dataKeyChange(dataKey) {
      if (fun.isNull(dataKey)) {
        this.tableAlarmList = []
        return
      }
      let arr = this.dataPointList.filter(item => {
        return item.dataKey == dataKey
      })
      this.dialog.elForm.dataUnit = arr[0].dataUnit
      this.dialog.elForm.dataName = arr[0].dataName
      //码索引
      this.loadTableAlarmList(arr[0].ptId, arr[0].id)
    },
    //瞬时量和累积量下拉事件
    chartSelect(isInstant) {
      if (isInstant) {
        const selectedItemId = this.dialog.elForm.instantId;
        const selectedItem = this.curveList.find(item => item.id === selectedItemId);
        this.dialog.elForm.dataUnit = selectedItem.unit
        this.dialog.elForm.dataName = selectedItem.recordName;
      } else {
        const selectedItemId = this.dialog.elForm.cumulateId;
        const selectedItem = this.cumulateList.find(item => item.id === selectedItemId);
        this.dialog.elForm.dataUnit = selectedItem.unit
        this.dialog.elForm.dataName = selectedItem.recordName;
      }
    },
    //查询EMS数据配置列表
    loadEmsDataList() {
      if(this.stationSelVal){
        let data = {
          keyword: this.keywordVal,
          staId: this.stationSelVal,
          devId: this.devSelVal,
          sourceType: this.sourceTypeSelVal,//源类型
          modelType: this.modelTypeSelVal,//模块类型
          cumulateType: this.cumulateTypeSelVal,//累积量类型
          enableSign: this.enableSignSelVal,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        }
        this.loading = true
        this.$axios.post(myApi.getEMSConfigList, data).then(res => {
          if (res.data.code === myConst.code.success && res.data.data.list !== null) {
            this.dataList = res.data.data.list
            this.pageTotal = res.data.data.total
            this.loading = false
          } else {
            this.dataList = []
            this.pageTotal = 0
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          this.pageTotal = 0
          this.dataList = []
        })
      } else {
        this.$message({message:"请选择电站~", type:"info"})
      }
      
    },

    //搜索按钮点击事件
    selectButClick() {
      this.loadEmsDataList()
    },

    //翻页器
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadEmsDataList()
    },

    //根据id查询单条记录
    getOneData(id) {
      this.$axios.get(myApi.getOneEMSConfigInfo + '?id=' + id).then(res => {
        if (res.data.code === myConst.code.success) {
          this.dialog.elForm = res.data.data
          this.dialog.elForm.sourceType = res.data.data.sourceType + ""
          this.dialog.elForm.modelType = res.data.data.modelType + ""
          this.dialog.elForm.cumulateType = res.data.data.cumulateType + ""
          this.dialog.elForm.decimalLen = res.data.data.decimalLen + ""
          this.dialog.elForm.enableSign = res.data.data.enableSign + ""
          this.comparisonData = JSON.parse(JSON.stringify(this.dialog.elForm))
          this.handleSourceTypeChange()
        }
      })
    },
    //根据点表id查询数据点
    loadDataPointList(id) {
      let data = {
        ptId: id
      }
      this.$axios.post(myApi.getDataPointbusGetList, data).then(res => {
        if (res.data.code === myConst.code.success) {
          this.dataPointList = res.data.data
        } else {
          this.dataPointList = []
        }
      })
    },
    //查询点表告警码获取码索引
    loadTableAlarmList(ptId, dataId) {
      let data = {
        ptId: ptId,
        ptDataId: dataId,
      }
      this.$axios.post(myApi.getAlarmBusList, data).then(res => {
        if (res.data.code === myConst.code.success) {
          this.tableAlarmList = res.data.data
        } else {
          this.$message({message: res.data.msg, type: "info"})
          this.tableAlarmList = []
        }
      }).catch(() => {
        this.tableAlarmList = []
      })
    },
    //加载曲线列表
    loadCurveList() {
      if (this.stationSelVal == "") {
        this.curveList = []
        return
      }
      this.$axios.get(myApi.stationCurveGetListBus + "?staId=" + this.stationSelVal).then(res => {
        if (res.data.code === myConst.code.success) {
          this.curveList = res.data.data;
        } else {
          this.curveList = [];
        }
      }).catch(() => {
        this.curveList = [];
      });
    },
    //加载累积量列表
    loadCumulateList() {
      if (this.stationSelVal == "") {
        this.cumulateList = []
        return
      }
      this.$axios.get(myApi.stationCumulateGetListBus + "?staId=" + this.stationSelVal).then(res => {
        if (res.data.code === myConst.code.success) {
          this.cumulateList = res.data.data;
        } else {
          this.cumulateList = [];
        }
      }).catch(() => {
        this.cumulateList = [];
      });
    },
    //增加按钮点击事件
    addClick() {
      this.dialog.title = "添加"
      this.dialogTableVisible = true
      this.dialog.openType = 2;
      this.resetData()
    },
    //删除所有点击事件(根据单位或电站删除)
    deleteClick() {
      this.$confirm("确认删除所有EMS配置吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        let data = {
          staId: this.stationSelVal,
          modelType: this.modelTypeSelVal,
          sourceType: this.sourceTypeSelVal
        }
        this.$axios.post(myApi.deleteEMSConfig, data).then(res => {
          if (res.data.code === myConst.code.success) {
            this.loadEmsDataList()
            this.$message({message: res.data.data, type: "success"})
          } else {
            this.$message({message: res.data.msg, type: "info"})
          }
        })
      }).catch(() => {
      })
    },
    //转换瞬时量名称
    convertInstantName(instantId) {
      const item = this.curveList.find(curve => curve.id === instantId);
      return item ? item.recordName : null;
    },
    //转换累积量名称
    convertCumulateName(cumulateId) {
      const item = this.cumulateList.find(cumulate => cumulate.id === cumulateId);
      return item ? item.recordName : null;
    },
    //详情按钮
    detailsClick(id, devId) {
      this.dialogTableVisible = true
      this.dialog.title = '详情'
      this.dialog.openType = 0;
      this.getOneData(id)
      this.handleDevChange(devId)
    },

    //编辑按钮
    editClick(id, devId) {
      this.dialogTableVisible = true
      this.dialog.title = '编辑'
      this.dialog.openType = 1;
      this.getOneData(id)
      this.handleDevChange(devId)
    },

    //删除按钮
    delClick(id, name) {
      this.$confirm(`确认删除 <span style="color: red;">${name}</span> 这个EMS数据配置吗？`,
          "提示", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
          }).then(() => {
        let data = {
          id: id
        }
        this.$axios.post(myApi.deleteEMSConfig, data).then(res => {
          if (res.data.code === myConst.code.success) {
            this.loadEmsDataList()
            this.$message({message: res.data.data, type: "success"})
          } else {
            this.$message({message: res.data.msg, type: "info"})
          }
        })
      }).catch(() => {
      })
    },

    //提交表单按钮
    submitClick(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.dialog.elForm.devId = fun.isNull( this.dialog.elForm.devId)? 0 : this.dialog.elForm.devId
          //如果当前处于添加状态
          if (this.dialog.openType === 2) {
            this.$confirm("确认要添加吗？", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
            }).then(() => {
              this.dialog.elForm.staId = this.stationSelVal
              this.$axios.post(myApi.addEMSConfig, this.dialog.elForm).then(res => {
                if (res.data.code === myConst.code.success) {
                  this.loadEmsDataList()
                  this.$message({message: res.data.data, type: "success"})
                } else {
                  this.$message({message: res.data.msg, type: "info"})
                }
              })
            }).catch(() => {
            })
          } else if (this.dialog.openType === 1) {
            let initData = JSON.stringify(this.comparisonData)
            let changeData = JSON.stringify(this.dialog.elForm)
            //检验当前修改有没有发生变化
            if (initData == changeData) {
              this.$message({
                message: "未发生改变",
                type: "info"
              })
            } else {
              this.$confirm("确认保存修改吗？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
              }).then(() => {
                this.$axios.post(myApi.alterEMSConfig, this.dialog.elForm).then(res => {
                  if (res.data.code === myConst.code.success) {
                    this.loadEmsDataList()
                    this.$message({message: res.data.data, type: "success"})
                  } else {
                    this.$message({message: res.data.msg, type: "info"})
                  }
                })
              }).catch(() => {
              })
            }
          }
        }
      })
    },

    //重置数据
    resetData() {
      return this.dialog.elForm = {
        id: "",
        recordName: "",//记录名称
        sourceType: "",//源类型
        modelType: "",//模块类型
        staId: "",//电站id
        devId: "", //设备id
        dataKey: "", //数据key
        codeIndex: "", //码索引
        instantId: "", //瞬时量id
        cumulateId: "", //累积量id
        cumulateType: "", //累积量类型
        dataName: "", //数据名称
        defaultValue: "", //默认值
        dataUnit: "", //数据单位
        ratio: "", //转换系数
        base: "", //转换截距
        groupSign: "", //分组标记
        groupName: "", //分组名称
        decimalLen: "", //小数位
        sortNumber: "", //排序号
        icon: "", //图标
        enableSign:  this.enableSignList[0].infoCode, //生效标记
        remark: "", //备注
      }
    },
    //表单重置按钮
    resetClick() {
      if (this.dialog.openType === 2) {//如果是添加 则重置数据
        this.resetData()
      } else {
        this.getOneData(this.dialog.elForm.id)
      }
    },
    //弹出框关闭操作
    closeDialog() {
      this.handleSourceTypeChange()
    },

       //设置列表前五列背景颜色
       rowClassName({row, column, rowIndex, columnIndex}) {
      if (columnIndex == 0 || columnIndex == 2 || columnIndex == 4) {
        return 'background:#022632'
      } else if (columnIndex == 1 || columnIndex == 3 || columnIndex == 5 || columnIndex == 20) {
        return 'background:#011d28'
      }
    },

    //设置表头前五列背景颜色
    ListTableHeaderColor({row, column, rowIndex, columnIndex}) {
      return 'background:#033646'

    },

  }
}
</script>

<style scoped>
@import "~@/assets/css/configInfo.css";

.btn_add {
  margin-right: 2rem;
}

</style>
